import { Controller } from "@hotwired/stimulus"

// Widget de Cloudflare Turnstile (formulario de registro). Se dibuja a mano
// (render=explicit): con Turbo el script se carga una sola vez y el render
// automático no volvería a correr al entrar de nuevo a la página. El widget
// agrega al formulario el campo cf-turnstile-response que se verifica en el
// servidor (VerificadorTurnstile).
const SCRIPT = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
let cargando

function cargarTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile)

  cargando ||= new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = SCRIPT
    script.async = true
    script.onload = () => resolve(window.turnstile)
    script.onerror = () => { cargando = null; reject(new Error("No se pudo cargar Turnstile")) }
    document.head.appendChild(script)
  })
  return cargando
}

export default class extends Controller {
  static values = { clave: String }

  async connect() {
    // Una copia restaurada por Turbo trae el iframe viejo, que ya no funciona.
    this.element.replaceChildren()
    try {
      const turnstile = await cargarTurnstile()
      if (!this.element.isConnected) return
      this.widget = turnstile.render(this.element, { sitekey: this.claveValue, language: "es", theme: "light" })
    } catch (error) {
      console.warn(error)
    }
  }

  disconnect() {
    if (this.widget !== undefined && window.turnstile) window.turnstile.remove(this.widget)
    this.widget = undefined
  }
}
